'use strict';

module.exports = {
  national: 'national',
  regional: 'regional',
  hyperlocal: 'hyperlocal',
};
